import { FormattedMessage } from "react-intl";
import React from "react";

export const selectOpts = [
  {
    value: "true",
    label: (
      <FormattedMessage
        id="sna.sidebar.adjusttool.legend.show.nodata.group.yes"
        defaultMessage="是"
      />
    ),
  },
  {
    value: "false",
    label: (
      <FormattedMessage
        id="sna.sidebar.adjusttool.legend.show.nodata.group.no"
        defaultMessage="否"
      />
    ),
  },
];
